'use client'

import { useQuoteCart } from './QuoteCart'
import { CART_ICON_PATH, openQuoteCart, useRegisterInPageCartTrigger } from './quoteCartDock'

export default function CatalogCartButton() {
  const { items, isLoaded } = useQuoteCart()
  useRegisterInPageCartTrigger()
  const count = isLoaded ? items.length : 0

  return (
    <button
      type="button"
      onClick={(e) => openQuoteCart(e.currentTarget)}
      aria-label={`Quote cart, ${count} ${count === 1 ? 'product' : 'products'}`}
      aria-haspopup="dialog"
      className="flex h-10 shrink-0 items-center gap-2 rounded-md bg-primary-ink-100 px-3 text-sm font-medium text-white transition-colors hover:bg-primary-ink-85 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-green-85 focus-visible:ring-offset-2 motion-reduce:transition-none">
      <svg
        aria-hidden="true"
        className="h-5 w-5"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.5}
        viewBox="0 0 24 24">
        <path d={CART_ICON_PATH} />
      </svg>
      <span className="hidden sm:inline">Quote cart</span>
      {count > 0 && (
        <span className="flex h-5 min-w-5 items-center justify-center rounded-full bg-white px-1.5 text-xs font-medium text-primary-ink-100">
          {count > 99 ? '99+' : count}
        </span>
      )}
    </button>
  )
}
